import { useMediaQuery, useTheme } from '@mui/material'

export function useMediaQueryState() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isOutlook = useMediaQuery('(max-width:360px)');

  return {
    isMobile,
    isPC: !isMobile,
    isOutlook
  };
}
